import Divider from '@rio-cloud/rio-uikit/components/divider/Divider';
import { CustomFormattedMessage } from '../../../../i18n/i18n';
import { useLocale } from '../../../../i18n/locale';
import { PartnerCard } from '../../../../components/PartnerCard';
import { openInNewTab } from '../../../../configuration/partnerLinks';
import { PARTNERS } from './partners';

export const OurPartners = () => {
  const { locale } = useLocale();

  return (
    <div
      className="margin-top-25"
      data-testid="our-partners-section"
    >
      <span className="padding-left-15">
        <CustomFormattedMessage id="overview.ourPartners.sectionTitle" />
      </span>
      <Divider />
      <div className="display-grid gap-10 grid-cols-1-xs grid-cols-2-sm grid-cols-4-md">
        {PARTNERS.map((partner) => (
          <PartnerCard
            key={partner.id}
            data-testid={`partner-card-${partner.id}`}
            image={partner.image}
            titleId={partner.titleId}
            descriptionId={partner.descriptionId}
            isExternalPartner={partner.isExternalPartner}
            onClick={() => openInNewTab(partner.buildLink(locale))}
          />
        ))}
      </div>
    </div>
  );
};
